import "./physicianDetailsEditComponent.scss";
import React, {useCallback, useEffect, useRef, useState} from "react";
import AccordionComponent from "../../../../../shared/components/accordion/accordionComponent";
import {CommonService} from "../../../../../shared/services";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import PhysicianDetailsComponent from "../../../../../shared/components/physician-details/PhysicianDetailsComponent";
import {ImageConfig} from "../../../../../constants";
import {IAPIResponseType} from "../../../../../shared/models/api.model";
import * as Yup from "yup";
import {Field, FieldProps, Formik, FormikProps, FormikValues} from "formik";
import {Grid} from "@mui/material";
import FormikInputComponent from "../../../../../shared/components/core/formik-input/FormikInputComponent";
import FeedbackComponent from "../../../../../shared/components/feedback/feedbackComponent";
import DrawerComponent from "../../../../../shared/components/drawer/drawerComponent";
import PhysicianDetailsFormComponent
    from "../../../../../shared/components/physician-details-form/PhysicianDetailsFormComponent";
import _ from "lodash";

interface physicianDetailsEditComponentProps {
    physicianDetailsList?: any;
    facilityId?: any;
    onUpdateComplete?: Function;
    onEditCancel: Function;
}

const facilityPhysicianDetailsValidationSchema = Yup.object({
    npiNumber: Yup.string()
        .nullable()
        .matches(/^[0-9]{10}$/, "NPI Number must be 10 digits"),
});


interface facilityPhysicianDetailsFormSchema {
    npiNumber: string;
}

const facilityInformationInitialValues: facilityPhysicianDetailsFormSchema = {
    npiNumber: "",
}
const initialPhysicianDrawerConfig = {
    isOpen: false as boolean,
    isNpiClearable: true as boolean,
    mode: undefined as "edit" | "add" | undefined,
}
const PhysicianDetailsEditComponent = (props: physicianDetailsEditComponentProps) => {
    const {physicianDetailsList, facilityId, onEditCancel, onUpdateComplete} = props;
    const formikRef = useRef<FormikProps<FormikValues>>(null);
    const [physicianList, setPhysicianList] = useState<any>(physicianDetailsList);
    const [isGetPhysicianDetailsLoading, setIsGetPhysicianDetailsLoading] = useState<boolean>(false);
    const [addPhysicianFormInitialValues, setAddPhysicianFormInitialValues] = useState<any>("");
    const [physicianDrawerConfig, setPhysicianDrawerConfig] = useState(initialPhysicianDrawerConfig);

    const handlePhysicianListUpdate = useCallback((physicianData: any, physicianMode: any) => {
        const physicianDetailsTemporaryList = _.cloneDeep(physicianList);
        if (physicianMode === 'add') {
            physicianDetailsTemporaryList.push(physicianData);
            setPhysicianList(physicianDetailsTemporaryList);
        } else {
            const index = physicianDetailsTemporaryList?.findIndex((item: any) => item.id === physicianData.id);
            physicianDetailsTemporaryList[index] = physicianData;
            setPhysicianList(physicianDetailsTemporaryList);
        }
        if (onUpdateComplete) {
            onUpdateComplete(physicianDetailsTemporaryList);
        }
        setPhysicianDrawerConfig(initialPhysicianDrawerConfig)
    }, [onUpdateComplete, physicianList]);

    // const onRemovePhysician = useCallback((physicianId: any) => {
    //     CommonService._facility.deletePhysician(facilityId, physicianId)
    //         .then((response: IAPIResponseType<any>) => {
    //             const physicianDetailsTemporaryList = _.cloneDeep(physicianList);
    //             const index = physicianDetailsTemporaryList?.findIndex((item: any) => item.id === response.data.id);
    //             physicianDetailsTemporaryList[index] = response.data;
    //             setPhysicianList(physicianDetailsTemporaryList);
    //             if (onUpdateComplete) {
    //                 onUpdateComplete(physicianDetailsTemporaryList);
    //             }
    //             CommonService._alert.showToast(response?.message || `Physician has been removed from the facility`, "success");
    //         })
    //         .catch((error: any) => {
    //             CommonService._alert.showToast(error?.error || `Error while removing the physician from the facility`, "error");
    //         });
    // }, [facilityId, onUpdateComplete, physicianList]);

    // const onRecoverPhysician = useCallback((physicianId: any) => {
    //     CommonService._facility.recoverPhysician(facilityId, physicianId)
    //         .then((response: IAPIResponseType<any>) => {
    //             const physicianDetailsTemporaryList = _.cloneDeep(physicianList);
    //             const index = physicianDetailsTemporaryList?.findIndex((item: any) => item.id === response.data.id);
    //             physicianDetailsTemporaryList[index] = response.data;
    //             setPhysicianList(physicianDetailsTemporaryList);
    //             if (onUpdateComplete) {
    //                 onUpdateComplete(physicianDetailsTemporaryList);
    //             }
    //             CommonService._alert.showToast(response?.message || `Physician has been removed from the facility`, "success");
    //         })
    //         .catch((error: any) => {
    //             CommonService._alert.showToast(error?.error || `Error while removing the physician from the facility`, "error");
    //         });
    // }, [facilityId, onUpdateComplete, physicianList]);

    // const handleRemoveAndRecoverPhysician = useCallback((physician: any) => {
    //     if (!physician.isDeleted) {
    //         CommonService.openConfirmationDialog({
    //             confirmationTitle: 'Please confirm!',
    //             confirmationSubTitle: "Are you sure you want to remove this provider/physician?",
    //             disableEscKeyClose: false,
    //             disableBackdropClose: true,
    //             imagePath: `${ImageConfig.ConfirmationImage}`,
    //             direction: "up",
    //             yes: {
    //                 text: "Remove",
    //                 color: "primary"
    //             },
    //             no: {
    //                 text: "Cancel"
    //             }
    //         })
    //             .then(() => {
    //                 onRemovePhysician(physician?.id);
    //             })
    //             .catch(() => {
    //             })
    //     } else {
    //         CommonService.openConfirmationDialog({
    //             confirmationTitle: 'Please confirm!',
    //             confirmationSubTitle: "Are you sure you want to restore this provider/physician?",
    //             disableEscKeyClose: false,
    //             disableBackdropClose: true,
    //             imagePath: `${ImageConfig.RestoreImage}`,
    //             direction: "up",
    //             yes: {
    //                 text: "Restore",
    //                 color: "primary"
    //             },
    //             no: {
    //                 text: "Cancel",
    //                 color: "primary"
    //             }
    //         })
    //             .then(() => {
    //                 onRecoverPhysician(physician?.id);
    //             })
    //             .catch(() => {
    //             })
    //     }
    //
    // }, [onRemovePhysician, onRecoverPhysician]);

    const editFacilityDetails = useCallback((physicianDetails: any) => {
        try {
            const payload = {
                physicians: [physicianDetails.id]
            }
            CommonService._facility.editFacilityDetails(facilityId, payload)
                .then((response: IAPIResponseType<any>) => {
                    setIsGetPhysicianDetailsLoading(false)
                    setPhysicianList((oldState: any) => {
                        if (oldState?.length > 0) {
                            return [...oldState, physicianDetails]
                        } else {
                            return [physicianDetails]
                        }
                    });
                    CommonService._alert.showToast(response?.message || `Physician has been added to the facility`, "success");
                })
                .catch((error: any) => {
                    CommonService._alert.showToast(error?.error || `Error adding physician to Facility`, "error");
                    setIsGetPhysicianDetailsLoading(false)
                });
        } catch (error: any) {
            console.error("Something went wrong edit facility details", error)
            CommonService._alert.showToast(error?.error || "Something went wrong editing facility details", 'error')
            setIsGetPhysicianDetailsLoading(false)
        }
    }, [facilityId])

    const handleRemovePhysicianFromFacility = useCallback((physician: any) => {
        try {
            CommonService.openConfirmationDialog({
                confirmationTitle: 'Please confirm!',
                confirmationSubTitle: "Are you sure you want to remove this provider/physician?",
                disableEscKeyClose: false,
                disableBackdropClose: true,
                imagePath: `${ImageConfig.ConfirmationImage}`,
                direction: "up",
                yes: {
                    text: "Remove",
                    color: "primary"
                },
                no: {
                    text: "Cancel"
                }
            })
                .then(() => {
                    const payload = {
                        physicians: physicianList.filter((physicianItem: any) => physicianItem?.id !== physician?.id)?.map((physicianItem: any) => physicianItem?.id),
                    }
                    CommonService._facility.updateFacilityUpdatePhysician(facilityId, payload).then((response) => {
                        setPhysicianList((oldState: any) => {
                            const updatedList = oldState.filter((physicianItem: any) => physicianItem.id !== physician?.id) || []
                            return updatedList;
                        })
                    }).catch((error) => {
                        CommonService._alert.showToast(error.error || "Error while deleting physician", "error")
                    })
                })
                .catch(() => {
                })
        } catch (error) {
            console.error("Error while remove physician from facility", error)
        }
    }, [physicianList, facilityId])

    const addPhysicianToFacility = useCallback((physicianDetails: any) => {
        CommonService._facility.addPhysicianInformation(facilityId, physicianDetails)
            .then((response: IAPIResponseType<any>) => {
                if (response.data?.isPhyscisianAlreadyExist) {
                    editFacilityDetails(response.data)
                } else {
                    setIsGetPhysicianDetailsLoading(false)
                    setPhysicianList((oldState: any) => {
                        if (oldState?.length > 0) {
                            return [...oldState, response.data]
                        } else {
                            return [response.data]
                        }
                    });
                    CommonService._alert.showToast(response?.message || `Physician has been added to the facility`, "success");
                }
            })
            .catch((error) => {
                CommonService._alert.showToast(error?.error || `Error adding physician to Facility`, "error");
                setIsGetPhysicianDetailsLoading(false)
            })
        formikRef?.current?.resetForm();
    }, [editFacilityDetails, facilityId])
    const verifyNpiPhysicianEmail = useCallback((physicianDetails: any) => {
        const physicianEmail = physicianDetails.email;
        if (physicianEmail) {
            addPhysicianToFacility(physicianDetails);
        } else {
            //Check if the physician is already exists in our database with email address
            CommonService._facility.getPhysicianDatabaseDetails(physicianDetails?.npiNumber, {}).then((response) => {
                //check if database physician having email or not;
                if (response.data?.emailId) {
                    addPhysicianToFacility(response.data || physicianDetails)
                } else {
                    CommonService.openConfirmationDialog({
                        confirmationTitle: "Email Address not found!",
                        confirmationSubTitle: 'Please update email address to assign physician/provider to the facility',
                        disableEscKeyClose: false,
                        disableBackdropClose: true,
                        imagePath: `${ImageConfig.ConfirmationImage}`,
                        direction: "up",
                        yes: {
                            text: "Proceed",
                            color: "primary"
                        },
                        no: {
                            text: "Cancel",
                            color: "secondary"
                        }
                    }).then(() => {
                        setAddPhysicianFormInitialValues(response.data || physicianDetails)
                        setPhysicianDrawerConfig((prev) => {
                            return {
                                mode: 'add',
                                isOpen: true,
                                isNpiClearable: false,
                            }
                        })
                    }).finally(() => {
                        formikRef?.current?.resetForm();
                        setIsGetPhysicianDetailsLoading(false)
                    })
                }
            }).catch((error) => {
                CommonService._alert.showToast(error?.error || `Error while fetching physician Details`, "error");
                setIsGetPhysicianDetailsLoading(false);
            })
        }
    }, [addPhysicianToFacility])

    const getNpiDetails = useCallback((npiNumber: string) => {
        const payload = {'npiNumber': npiNumber}
        const npiNumberList = physicianList?.map((physician: any) => physician?.npiNumber?.toString());
        if (npiNumberList?.includes(npiNumber?.toString())) {
            CommonService._alert.showToast(`Physician already exists`, "error");
            return
        }
        setIsGetPhysicianDetailsLoading(true)
        CommonService._facility.getPhysicainDetails(payload)
            .then((response: IAPIResponseType<any>) => {
                    verifyNpiPhysicianEmail(response.data);
                }
            )
            .catch((error: any) => {
                CommonService._alert.showToast(error?.error || `Error while Fetching physician Details`, "error");
                setIsGetPhysicianDetailsLoading(false);
            })
    }, [physicianList, verifyNpiPhysicianEmail])

    const handlephysicianDrawerOpen = useCallback((mode: typeof initialPhysicianDrawerConfig["mode"], initialValues?: any) => {
        if (mode === 'edit') {
            if (initialValues?.designation !== 'md') {
                initialValues['otherDesignation'] = initialValues.designation;
                initialValues.designation = 'other';
            } else {
                initialValues['otherDesignation'] = '';
            }
        }
        setAddPhysicianFormInitialValues(initialValues);
        setPhysicianDrawerConfig((prev) => {
            return {
                ...prev,
                mode: mode,
                isOpen: true,
                isNpiClearable: true,
            }
        })
    }, [])

    return (
        <div className={'physician-details-edit-component details-tab-data-content'}>
            <div className={'t-form-controls-wrapper'}>
                <Formik
                    validationSchema={facilityPhysicianDetailsValidationSchema}
                    initialValues={facilityInformationInitialValues}
                    validateOnChange={false}
                    validateOnBlur={true}
                    enableReinitialize={true}
                    validateOnMount={true}
                    innerRef={formikRef}
                    onSubmit={() => {
                    }}
                >
                    {({isSubmitting, values, isValid, setFieldValue, validateForm, resetForm}) => {
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        useEffect(() => {
                            validateForm();
                        }, [validateForm, values]);
                        return (
                            <>
                                <Grid container spacing={2} paddingTop={"6px"}>
                                    <Grid item xs={12} sm={6}>
                                        <Field name={'npiNumber'}>
                                            {
                                                (field: FieldProps) => (
                                                    <FormikInputComponent
                                                        label={"Provider NPI Lookup"}
                                                        placeholder={'Enter 10-digit NPI Number'}
                                                        formikField={field}
                                                        type={"text"}
                                                        maxLength={10}
                                                        required={true}
                                                    />
                                                )
                                            }
                                        </Field>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <ButtonComponent
                                            className="mrg-left-20 mrg-top-5"
                                            disabled={!isValid || isSubmitting || values.npiNumber === ''}
                                            color={"secondary"}
                                            variant={"outlined"}
                                            fullWidth={false}
                                            size={'large'}
                                            isLoading={isGetPhysicianDetailsLoading}
                                            handleClick={() => getNpiDetails(values.npiNumber)}>
                                            Fetch Details
                                        </ButtonComponent>
                                        <ButtonComponent
                                            className="mrg-left-20 mrg-top-5"
                                            variant={"outlined"}
                                            size={"large"}
                                            handleClick={() => handlephysicianDrawerOpen('add')}
                                        >
                                            Add Provider/Physician manually
                                        </ButtonComponent>
                                    </Grid>
                                </Grid>
                            </>
                        )
                    }
                    }
                </Formik>
                <div className={'form-sub-title mrg-top-20 mrg-bottom-20'}>Added Providers</div>
                {!physicianList?.length ?
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <FeedbackComponent>
                                No provider/physician have been
                                added.
                            </FeedbackComponent>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            {/*<ButtonComponent*/}
                            {/*    variant={"outlined"}*/}
                            {/*    fullWidth={true}*/}
                            {/*    handleClick={() => handlephysicianDrawerOpen('add')}*/}
                            {/*>*/}
                            {/*    Add Provider/Physician*/}
                            {/*</ButtonComponent>*/}
                        </Grid>
                    </Grid> :
                    <>
                        {physicianList?.map((physician: any, index: any) => {
                                return (
                                    <div key={index} className="accordion-layout mrg-bottom-20">
                                        <AccordionComponent
                                            // disabled={!values.physicianId}
                                            isExpanded={physicianList[index]?.isPhysicianExpand}
                                            title={CommonService.physicianWithPrefix(physician)}
                                            subTitle={`(NPI: ${physician?.npiNumber || "N/A"} | ${physicianList[index]?.roleObj?.title || ""})`}
                                            actions={
                                                physicianList[index]?.roleObj?.title === "Facility Admin" ?
                                                    <></> :
                                                    <ButtonComponent
                                                        startIcon={<RemoveCircleIcon/>}
                                                        variant={"outlined"}
                                                        size={"small"}
                                                        fullWidth={false}
                                                        type={'button'}
                                                        color={"primary"}
                                                        handleClick={
                                                            () => {
                                                                // handleRemoveAndRecoverPhysician(physician)
                                                                handleRemovePhysicianFromFacility(physician)
                                                            }
                                                        }

                                                    >
                                                        {/*{!physician.isDeleted ? 'Remove' : 'Recover'}*/}
                                                        Remove
                                                    </ButtonComponent>}
                                            onChange={(isExpanded) => {
                                                if (isExpanded) {
                                                    // setCurrentPhysicianIndex(index);
                                                }
                                                // setFieldValue(`physicianDetails[${index}].isPhysicianExpand`, isExpanded);
                                            }}
                                        >
                                            <div className="physician-details-section">
                                                <div
                                                    className={'d-flex justify-content-space-between mrg-top-15 align-items-center'}>
                                                    <div className="form-sub-title">
                                                        Personal Details
                                                    </div>
                                                    {/*<ButtonComponent*/}
                                                    {/*    variant={"outlined"}*/}
                                                    {/*    fullWidth={false}*/}
                                                    {/*    type={'button'}*/}
                                                    {/*    color={"primary"}*/}
                                                    {/*    handleClick={() => {*/}
                                                    {/*        handlephysicianDrawerOpen('edit', physician);*/}
                                                    {/*    }}*/}
                                                    {/*    startIcon={<Edit/>}*/}
                                                    {/*>*/}
                                                    {/*    Edit Details*/}
                                                    {/*</ButtonComponent>*/}
                                                </div>
                                                <PhysicianDetailsComponent physician={physician}/>
                                            </div>
                                        </AccordionComponent>
                                    </div>
                                )
                            }
                        )}


                    </>
                }
            </div>
            <div className="form-action-section-edit">
                {/*<ButtonComponent*/}
                {/*    className={"width-25"}*/}
                {/*    color={"secondary"}*/}
                {/*    type={"button"}*/}
                {/*    variant={"outlined"}*/}
                {/*    handleClick={() => {*/}
                {/*        onEditCancel(physicianList);*/}
                {/*    }}*/}
                {/*    fullWidth={false}*/}
                {/*>*/}
                {/*    Cancel*/}
                {/*</ButtonComponent>*/}
                <ButtonComponent
                    className="width-25"
                    type="button"
                    color={"primary"}
                    variant={"contained"}
                    fullWidth={false}
                    handleClick={() => {
                        onEditCancel(physicianList);
                    }}
                >
                    Done
                </ButtonComponent>
            </div>

            <DrawerComponent open={physicianDrawerConfig.isOpen}
                             closeOnBackDropClick={true}
                             closeOnEsc={true}
                             onClose={() => setPhysicianDrawerConfig(initialPhysicianDrawerConfig)}
            >
                <PhysicianDetailsFormComponent
                    physicianList={physicianList}
                    facilityID={facilityId}
                    onUpdateComplete={handlePhysicianListUpdate}
                    formInitialValues={addPhysicianFormInitialValues}
                    physicianMode={physicianDrawerConfig.mode}
                    isNpiClearable={physicianDrawerConfig.isNpiClearable}
                />
            </DrawerComponent>
        </div>
    );

};

export default PhysicianDetailsEditComponent;
